<script lang="ts">
    import TourPriceAside from '$saga/views/Tour/TourPriceAside.svelte';

    export let originalPrice: number,
        rebateAmount: number,
        minPrice: number,
        dict: any;
</script>

<TourPriceAside {originalPrice} {rebateAmount} {minPrice} {dict} />
